// extracted by mini-css-extract-plugin
export default {"countDown":"style_countDown__r66Xa"};